export default "__VITE_ASSET__7536d51d__"